import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

// Sends an ajax request to record when an external link is clicked

// Connects to data-controller="recorded-link"
export default class extends Controller {
  static values = {
    url: String,
  };

  record({ params }) {
    const externalUrl = this.element.getAttribute("href");
    post(this.urlValue, {
      body: { url: externalUrl, identifier: params.identifier },
    });
  }
}
